import type { IconProps } from '../types/IconProps.ts';
export const ArrowUpLeft: IconProps = {
    name: 'ArrowUpLeft',
    children: [
        `<path d="m8 8 9 9M7 17V7.5c0-.28.22-.5.5-.5H17" />`,
    ]
};